import React, { useEffect, useState } from "react";
import LigneImpotDetaille from "./LigneImpot";
import CardBox from "components/ui/controls/card-box/card-box";
import Column from "components/ui/layout/column/column";
import { AppContext } from "components/app/RemExprertProvider";
import { useContext } from "react";
import TextField from "components/ui/controls/text-field/text-field";
import Button from "components/ui/controls/button/button";
import { FaCalculator, FaSync, FaPiggyBank } from "react-icons/fa";
import { RemExpertResultatTNS } from "components/app/Api/ResultatRemExpertTNSProvider";
import { RemExpertResultatSalarie } from "components/app/Api/ResultatRemExpertSalarieProvider";
import { createStyledButton } from "components/ui/controls/button/button-styles";
import "./ContexteFiscal.css";
import Row from "components/ui/layout/row/row";
import InfoMessage from "components/ui/controls/info-message/info-message";

const DeductionEpargne = (props) => {
  const context = useContext(AppContext);
  const ResultatTNS = useContext(RemExpertResultatTNS);
  const ResultatSalarie = useContext(RemExpertResultatSalarie);  const { Outil } = props;
  let Annee = new Date().getFullYear();
  const AnneePrec = Annee - 1; // Année précédente
  const [PlafondTotalClient, SetPlafondTotalClient] = useState(0);
  const [PlafondTotalConjoint, SetPlafondTotalConjoint] = useState(0);

  const handleCalculPlafondPerp = () => {
    let PlafondTotalCotisationPerpDirigeant = 0;
    let PlafondTotalCotisationPerpConjoint = 0;

    PlafondTotalCotisationPerpDirigeant = Math.max(
      0,
      Number(context.state[Outil + "IRDirigeantPlafondNM1"]) +
        Number(context.state[Outil + "IRDirigeantPlafond1"]) +
        Number(context.state[Outil + "IRDirigeantPlafond2"]) +
        Number(context.state[Outil + "IRDirigeantPlafond3"])
    );

    PlafondTotalCotisationPerpConjoint = Math.max(
      0,
      Number(context.state[Outil + "IRConjointPlafondNM1"]) +
        Number(context.state[Outil + "IRConjointPlafond1"]) +
        Number(context.state[Outil + "IRConjointPlafond2"]) +
        Number(context.state[Outil + "IRConjointPlafond3"])
    );

    SetPlafondTotalClient(PlafondTotalCotisationPerpDirigeant);
    SetPlafondTotalConjoint(PlafondTotalCotisationPerpConjoint);
  };

  useEffect(() => {
    handleCalculPlafondPerp();
  });

  useEffect(() => {
    // if (context.state.SetIRDirigeantPlafondNM1 === false) {

    const PeriodeClient = context.state[Outil + "PeriodeActuelle"][0];
    const PeriodeConjoint = context.state[Outil + "PeriodeActuelleConjoint"] === undefined ? undefined : context.state[Outil + "PeriodeActuelleConjoint"][0];
    let BrutImposableClient = 0;
    let BrutImposableConjoint = 0;
    if (Outil === "OptiRem") {
      BrutImposableClient += Number(ResultatTNS.state.OptiRemRemuneration?.BrutImposable);

      if (PeriodeConjoint !== undefined) {
        BrutImposableConjoint += Number(ResultatTNS.state.OptiRemRemunerationConjoint?.BrutImposable);
      } else if (context.state.InclureConjoint === true && PeriodeClient?.StatutConjoint !== "Aucun") {
        BrutImposableConjoint += Number(ResultatTNS.state.OptiRemRemunerationConjoint?.BrutImposable);
      }
    } else {
      if (PeriodeClient?.Statut === "TNS Article 62" || PeriodeClient?.Statut === "TNS individuel") {
        BrutImposableClient += Number(ResultatTNS.state.RemunerationTNS.BrutImposable);
      } else {
        BrutImposableClient += Number(ResultatSalarie.state["RemunerationSalarie"].BrutImposable);
      }

      if (PeriodeConjoint?.Statut === "TNS Article 62" || PeriodeConjoint?.Statut === "TNS individuel") {
        BrutImposableConjoint += Number(ResultatTNS.state.RemunerationTNSConjoint.BrutImposable);
      } else {
        BrutImposableConjoint += Number(ResultatSalarie.state.RemunerationSalarieConjoint.BrutImposable);
      }

      if (context.state.InclureConjoint === true && PeriodeClient?.StatutConjoint !== "Aucun") {
        if (PeriodeClient?.StatutConjoint === "TNS Article 62" || PeriodeClient?.StatutConjoint === "TNS individuel") {
          BrutImposableConjoint += Number(ResultatTNS.state.RemunerationTNSConjoint.BrutImposable);
        } else {
          BrutImposableConjoint += Number(ResultatSalarie.state.RemunerationSalarieConjoint.BrutImposable);
        }
      }
    }
    if (PeriodeClient !== undefined || context.state.TypeSimulation === "Audit rémunération") {
      let DividendeClient = PeriodeClient && PeriodeClient.DividendeBrut ? PeriodeClient.DividendeBrut : 0;
      const DividendeConjoint = PeriodeConjoint && PeriodeConjoint.DividendeBrut ? PeriodeConjoint.DividendeBrut : 0;
      if (context.state.TypeSimulation === "Audit rémunération" && Outil !== "OptiRem") {
        BrutImposableClient = context.state.RemExpressRemImposable;
        DividendeClient = context.state.RemExpressDividendeBrut;
      }
      ResultatTNS.GetImpot(Outil, context.state, BrutImposableClient, BrutImposableConjoint, Number(DividendeClient) + Number(DividendeConjoint)).then((DetailImpot) => {
        if (context.state[Outil + "SetIRDirigeantPlafondNM1"] === false) {
          context.handleValueChange(Outil + "IRDirigeantPlafondNM1", DetailImpot.PlafondPerpTheoriqueDirigeant);
        }
        if (context.state[Outil + "SetIRConjointPlafondNM1"] === false) {
          context.handleValueChange(Outil + "IRConjointPlafondNM1", DetailImpot.PlafondPerpTheoriqueConjoint);
        }
      });
    }

    // }
    //eslint-disable-next-line react-hooks/exhaustive-deps
  }, [context.state[Outil + "SetIRDirigeantPlafondNM1"], context.state[Outil + "SetIRConjointPlafondNM1"]]);

  return (
    <div className="revenuspro-container">
      {/* Header séparé */}
      <div className="header-card">
        <div className="category-column">
          <span className="header-icon">🏦</span>
          Déductions d'épargne retraite
        </div>
        <div className="value-column">
          <span className="header-icon">👤</span>
          Client
        </div>
        <div className="value-column">
          <span className="header-icon">👥</span>
          Conjoint
        </div>
      </div>

      {/* Conteneur des cartes de contenu */}
      <div className="card-list-container">
        {/* Plafond non utilisé sur les revenus N-3 */}
        <div className="card">
          <div className="category-column">
            <div className="titre-icone">📅</div>
            Plafond non utilisé sur les revenus {Annee - 3}
          </div>
          <div className="value-column">
            <TextField
              value={context.state[Outil + "IRDirigeantPlafond1"]}
              onChange={(e) => context.handleValueChange(Outil + "IRDirigeantPlafond1", e.target.value)}
              dataType="uint"
              format={{ thousands: " ", unit: " €" }}
              normal
            />
          </div>
          <div className="value-column">
            <TextField
              value={context.state[Outil + "IRConjointPlafond1"]}
              onChange={(e) => context.handleValueChange(Outil + "IRConjointPlafond1", e.target.value)}
              dataType="uint"
              format={{ thousands: " ", unit: " €" }}
              normal
            />
          </div>
        </div>

        {/* Plafond non utilisé sur les revenus N-2 */}
        <div className="card">
          <div className="category-column">
            <div className="titre-icone">📅</div>
            Plafond non utilisé sur les revenus {Annee - 2}
          </div>
          <div className="value-column">
            <TextField
              value={context.state[Outil + "IRDirigeantPlafond2"]}
              onChange={(e) => context.handleValueChange(Outil + "IRDirigeantPlafond2", e.target.value)}
              dataType="uint"
              format={{ thousands: " ", unit: " €" }}
              normal
            />
          </div>
          <div className="value-column">
            <TextField
              value={context.state[Outil + "IRConjointPlafond2"]}
              onChange={(e) => context.handleValueChange(Outil + "IRConjointPlafond2", e.target.value)}
              dataType="uint"
              format={{ thousands: " ", unit: " €" }}
              normal
            />
          </div>
        </div>

        {/* Plafond non utilisé sur les revenus N-1 */}
        <div className="card">
          <div className="category-column">
            <div className="titre-icone">📅</div>
            Plafond non utilisé sur les revenus {Annee - 1}
          </div>
          <div className="value-column">
            <TextField
              value={context.state[Outil + "IRDirigeantPlafond3"]}
              onChange={(e) => context.handleValueChange(Outil + "IRDirigeantPlafond3", e.target.value)}
              dataType="uint"
              format={{ thousands: " ", unit: " €" }}
              normal
            />
          </div>
          <div className="value-column">
            <TextField
              value={context.state[Outil + "IRConjointPlafond3"]}
              onChange={(e) => context.handleValueChange(Outil + "IRConjointPlafond3", e.target.value)}
              dataType="uint"
              format={{ thousands: " ", unit: " €" }}
              normal
            />
          </div>
        </div>

        {/* Plafond calculé sur les revenus N-1 avec bouton calculé/fixé */}
        <div className="card">
          <div className="category-column">
            <div className="titre-icone">🧮</div>
            Plafond calculé sur les revenus {Annee - 1}
          </div>
          <div className="value-column">
            <TextField
              iconBefore={
                <Button 
                  tabIndex="-1" 
                  icon 
                  onClick={() => context.handleValueChange(Outil + "SetIRDirigeantPlafondNM1", false)}
                  {...createStyledButton("card-action", context.state[Outil + "SetIRDirigeantPlafondNM1"] === false ? "cardEdit" : "secondary",{ backgroundColor:"rgb(219, 234, 254)"})}
                  title={context.state[Outil + "SetIRDirigeantPlafondNM1"] === false ? "Mode automatique - Cliquer pour passer en manuel" : "Mode manuel - Cliquer pour repasser en automatique"}
                >
                  {context.state[Outil + "SetIRDirigeantPlafondNM1"] === false ? 
                    <FaCalculator style={{ color: "rgb(59, 130, 246)", fontSize: "12px" }} /> : 
                    <FaSync style={{ color: "rgb(59, 130, 246)", fontSize: "12px" }} />
                  }
                </Button>
              }
              value={context.state[Outil + "IRDirigeantPlafondNM1"]}
              onChange={(e) => {
                context.handleValueChange(Outil + "SetIRDirigeantPlafondNM1", true);
                context.handleValueChange(Outil + "IRDirigeantPlafondNM1", e.target.value);
              }}
              dataType="uint"
              format={{ thousands: " ", unit: " €" }}
              normal
            />
          </div>
          <div className="value-column">
            <TextField
              iconBefore={
                <Button 
                  tabIndex="-1" 
                  icon 
                  onClick={() => context.handleValueChange(Outil + "SetIRConjointPlafondNM1", false)}
                  {...createStyledButton("card-action", context.state[Outil + "SetIRConjointPlafondNM1"] === false ? "cardEdit" : "secondary",{ backgroundColor:"rgb(219, 234, 254)"})}
                  title={context.state[Outil + "SetIRConjointPlafondNM1"] === false ? "Mode automatique - Cliquer pour passer en manuel" : "Mode manuel - Cliquer pour repasser en automatique"}
                >
                  {context.state[Outil + "SetIRConjointPlafondNM1"] === false ? 
                    <FaCalculator style={{ color: "rgb(59, 130, 246)", fontSize: "12px" }} /> : 
                    <FaSync style={{ color: "rgb(59, 130, 246)", fontSize: "12px" }} />
                  }
                </Button>
              }
              value={context.state[Outil + "IRConjointPlafondNM1"]}
              onChange={(e) => {
                context.handleValueChange(Outil + "SetIRConjointPlafondNM1", true);
                context.handleValueChange(Outil + "IRConjointPlafondNM1", e.target.value);
              }}
              dataType="uint"
              format={{ thousands: " ", unit: " €" }}
              normal
            />
          </div>
        </div>

        {/* Plafond total pour les cotisations */}
        <div className="card">
          <div className="category-column">
            <div className="titre-icone">💰</div>
            Plafond pour les cotisations versées en {Annee}
          </div>
          <div className="value-column">
            <TextField 
              disabled 
              value={PlafondTotalClient} 
              dataType="uint" 
              format={{ thousands: " ", unit: " €" }} 
              normal 
            />
          </div>
          <div className="value-column">
            <TextField 
              disabled 
              value={PlafondTotalConjoint} 
              dataType="uint" 
              format={{ thousands: " ", unit: " €" }} 
              normal 
            />
          </div>
        </div>
      </div>           <Row>
              <InfoMessage text={`Dans la mesure où le logiciel n'a pas connaissance des revenus N-1, le plafond de l'année ${Annee} est calculé sur les revenus de l'année en cours. Vous pouvez corriger le montant en vous basant sur les revenus de l'année ${AnneePrec}.`} />
            </Row>
    </div>
  );
};

export default DeductionEpargne;
